<template>
	<div>
		<!-- 预入住统计 -->
		<section>
			<el-form :model="formInline" :inline="true" label-width="100px">
				<el-form-item label="业主名称">
					<el-input v-model="formInline.unitName" placeholder="输入姓名" style="width: 120px;" clearable=""></el-input>
				</el-form-item>
				<el-form-item label="标签">
					<el-select v-model="formInline.label" placeholder="选择标签" style="width: 120px;" clearable="">
						<el-option :label="item.label" :value="item.label" v-for="item in checkStatus"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="负责人">
					<el-input v-model="formInline.userName" placeholder="输入负责人" style="width: 120px;" clearable=""></el-input>
				</el-form-item>
				<el-form-item label="登记状态">
					<el-select v-model="formInline.registerFlag" placeholder="选择登记状态" style="width: 150px;" clearable="">
						<el-option label="已登记" value="已登记"></el-option>
						<el-option label="未登记" value="未登记"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleQuery">搜索</el-button>
				</el-form-item>
				<el-row style="float: right;margin-right: 20px;">
					<el-button type="warning" @click="exportData">导出</el-button>
				</el-row>
			</el-form>
			<p class="allTotalNum">
				<span>
					业主数：{{allTotalData.ownerNum}}
				</span>
				<span>
					预住客房数：{{allTotalData.subscribeRoomNum}}
				</span>
				<span>
					预住人才数：{{allTotalData.subscribeTalentNum}}
				</span>
				<span>
					已登记业主数：{{allTotalData.trueOwnerNum}}
				</span>
				<span>
					未登记业主数：{{allTotalData.falseOwnerNum}}
				</span>
				<span>
					已登记人才数：{{allTotalData.registerTalentNum}}
				</span>
			</p>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column prop="abbreviation" label="业主名称" align="center">
				</el-table-column>
				<!-- <el-table-column prop="organizationCode" label="组织代码" align="center">
				</el-table-column> -->
				<el-table-column prop="label" label="标签" align="center">
				</el-table-column>
				<el-table-column prop="username" label="负责人" align="center">
					<template slot-scope="scope">
						<span>{{scope.row.registerFlag=='已登记'?scope.row.username:'未完善'}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="phone" label="负责人电话" align="center">
					<template slot-scope="scope">
						<span>{{scope.row.registerFlag=='已登记'?scope.row.phone:'未完善'}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="roomNum" label="已预订客房数/客房数" align="center">
					<template slot-scope="scope">
						<span>{{!scope.row.roomAllNum?0:scope.row.roomAllNum}}/{{scope.row.roomNum}}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="fireControlFlag" label="是否已读消防" align="center">
				</el-table-column>
				<el-table-column prop="propertyFlag" label="是否已读物业收费" align="center">
				</el-table-column> -->
			</el-table>
			<el-pagination background :page-size="pageSize" layout="total, prev, pager, next,sizes" @current-change="handleCurrentChange"
			 :total="totalNum" @size-change="handleSizeChange" />
		</section>
	</div>
</template>

<script>
	import publicExport from '../../assets/js/publicExport.js'

	export default {
		data() {
			return {
				formInline: {
					unitName: null, //单位名称
					label: null, //标签
					name: null, //负责人
					registerFlag: null, //是否登记
				},
				tableData: [],
				pageSize: 10, //
				currentPage: 1, //当前页号
				totalNum: 0, //总页数
				title: "",
				dialogVisible: false,
				flag: null,
				formData: {},
				// 所有标签
				checkStatus: [{
						label: "高校",
						value: 2,
					},
					{
						label: "省属企业",
						value: 3,
					},
					{
						label: "科研院",
						value: 4,
					},
					{
						label: "其他",
						value: 5,
					},
				],
				// 所有业主数和预订房间数
				allTotalData: {},
			}
		},
		mounted() {
			this.getAll();
			this.getOwnerAndRoomAndTalent();
		},
		methods: {
			getAll() {
				this.$http.post("/api/ownerManage/queryOwnerSubscribe", {
					...this.formInline,
					currentPage: this.currentPage,
					pageSize: this.pageSize
				}).then(res => {
					this.tableData = res.data.data.items;
					this.totalNum = res.data.data.totalNum;
				})
			},

			// 统计所有业主和已预订房间人才数
			getOwnerAndRoomAndTalent() {
				this.$http.post("/api/ownerManage/countOwnerAndRoomAndTalent", { ...this.formInline
				}).then((res) => {
					console.log(res);
					this.allTotalData = { ...res.data.data
					};
				})
			},

			//查询
			handleQuery() {
				this.getAll();
				this.getOwnerAndRoomAndTalent();
			},

			// 分页
			// 当前页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getAll();
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.getAll();
			},

			// 导出
			exportData() {
				publicExport("/api/ownerManage/exportSubscribeOwner", this.formInline, "预入住统计")
			},
		}
	}
</script>

<style scoped="scoped">
	section {
		margin-top: 20px;
	}

	.allTotalNum {
		margin: 10px 0 20px 20px;
	}

	.allTotalNum>span {
		color: #606266;
		margin-right: 15px;
	}
</style>
